import queryString from "query-string";

import { createApiV2 } from "../common";

export const postAssignSchedule = (data) => (token) =>
  createApiV2("POST", "planner/assignment_schedule_entries/")(token, data);

export const patchAssignSchedule =
  ({ uid, data }) =>
  (token) =>
    createApiV2("PATCH", `planner/assignment_schedule_entries/${uid}/`)(token, data);

export const getAssignSchedule = (data) => (token) =>
  createApiV2("POST", "planner/assignment_schedule_entries/search")(token, data);

// One entry by uid, same shape as the board search. Used by "View on planner" to open the drawer for
// an assignee whose entry sits outside the loaded board window (so it isn't in the search results).
export const getScheduleEntry = (uid) => (token) =>
  createApiV2("GET", `planner/assignment_schedule_entries/${uid}/`)(token);

export const deleteAssignSchedule = (uid) => (token) =>
  createApiV2("DELETE", `planner/assignment_schedule_entries/${uid}/`)(token);

// F07 manual colour override. set/clear are POST detail actions; clear-all is a SOFT clear
// (the backend stamps override_cleared_at and KEEPS override_colour so it can be restored),
// restore un-stamps. All four are @require_roles(POWER_USERS) server-side; colour must be #RRGGBB.
export const postEntryColour =
  ({ uid, colour }) =>
  (token) =>
    createApiV2("POST", `planner/assignment_schedule_entries/${uid}/set_colour/`)(token, { colour });

export const postClearEntryColour =
  ({ uid }) =>
  (token) =>
    createApiV2("POST", `planner/assignment_schedule_entries/${uid}/clear_colour/`)(token);

export const deleteEntryColourOverrides = () => (token) =>
  createApiV2("DELETE", "planner/assignment_schedule_entries/colour_overrides/")(token);

// Company-wide count of active overrides, shown in the clear-all confirm ("Returns all N ..."). The
// backend shares one queryset with the DELETE above, so N always equals what clear-all will clear.
// Counts entries, not orders, and ignores the loaded date range (the board is date-bounded; this is not).
export const getEntryColourOverridesCount = () => (token) =>
  createApiV2("GET", "planner/assignment_schedule_entries/colour_overrides/count/")(token);

export const postRestoreEntryColours = () => (token) =>
  createApiV2("POST", "planner/assignment_schedule_entries/colour_overrides/restore/")(token);

export const getCustomEvents =
  (params = {}) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2("GET", `planner/events/?${queryParams}`)(token);
  };

export const getCustomEvent = (uid) => (token) =>
  createApiV2("GET", `planner/events/${uid}/`)(token);

export const postCustomEvent = (data) => (token) =>
  createApiV2("POST", `planner/events/`)(token, data);

export const putCustomEvent = (uid, data) => (token) =>
  createApiV2("PUT", `planner/events/${uid}/`)(token, data);

export const duplicateCustomEvent =
  (uid, params = {}) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2("GET", `planner/events/${uid}/duplicate_event/?${queryParams}`)(token);
  };

export const deleteCustomEventInstanceApi = (uid) => (token) =>
  createApiV2("DELETE", `planner/events/${uid}/delete_instance/`)(token);

export const deleteThisCustomEventApi = (uid, date) => (token) =>
  createApiV2("DELETE", `planner/events/${uid}/delete_this/${date}/`)(token);

export const deleteThisAndFollowingCustomEventApi = (uid, date) => (token) =>
  createApiV2("DELETE", `planner/events/${uid}/delete_this_and_following/${date}/`)(token);

export const deleteCustomAllEventApi = (uid) => (token) =>
  createApiV2("DELETE", `planner/events/${uid}/delete_all/`)(token);

export const getUndoDeleteCustomEventInstance = (uid) => (token) =>
  createApiV2("GET", `planner/events/${uid}/undo_delete_instance/`)(token);

export const getUndoDeleteThisCustomEvent = (uid, date) => (token) =>
  createApiV2("GET", `planner/events/${uid}/undo_delete_this/${date}/`)(token);

export const getUndoDeleteThisAndFollowingCustomEvent = (uid, date) => (token) =>
  createApiV2("GET", `planner/events/${uid}/undo_delete_this_and_following/${date}/`)(token);

export const getUndoDeleteCustomAllEvent = (uid) => (token) =>
  createApiV2("GET", `planner/events/${uid}/undo_delete_all/`)(token);

export const postMoveCardOrder = (data) => (token) =>
  createApiV2("POST", "workflow/move_order/")(token, data);
